module.exports = __webpack_public_path__ + "static/media/SelfCompassionAndAcceptance.c230b23c.mp3";